/**
 * 차단(gate_blocked) 룰 상세 상단의 "차단 사유" 박스 (D15).
 *
 * 룰 `provenance.gate_issues`를 보여준다. 제품 `checks.gate_issues`("대상 제품 검산 이슈")와
 * 별개다 — 이쪽은 이 룰이 왜 판정에서 빠졌는지다. 비어 있으면 확인 필요 문구를 보인다.
 * 순수 프리젠테이션 — 상위(상세 페이지)가 gate_issues를 뽑아 넘긴다(ARCHITECTURE §2).
 */
import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export interface GateReasonBoxProps {
  gateIssues: string[];
}

export const GATE_ISSUES_EMPTY_TEXT = "차단 사유 기록 없음 — 약사 확인 필요";

const Box = styled.div`
  border: 1px solid ${COLOR_SYSTEM.get("Red")?.[100]};
  background-color: ${COLOR_SYSTEM.get("Red")?.[10]};
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Red")?.[800]};
`;

const Title = styled.div`
  font-weight: 700;
  margin-bottom: 4px;
`;

const Empty = styled.div`
  color: ${COLOR_SYSTEM.get("Red")?.[700]};
`;

const GateReasonBox: React.FC<GateReasonBoxProps> = ({ gateIssues }) => (
  <Box>
    <Title>차단 사유</Title>
    {gateIssues.length > 0 ? (
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {gateIssues.map((issue, i) => (
          <li key={i}>{issue}</li>
        ))}
      </ul>
    ) : (
      <Empty>{GATE_ISSUES_EMPTY_TEXT}</Empty>
    )}
  </Box>
);

export default GateReasonBox;
